import {Component, HostListener, Input, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {MsalService} from "@azure/msal-angular";
import {select, Store} from "@ngrx/store";
import {map} from "rxjs";
import {NotificationStatusEnum, OpenAPI, UserDtoExtended} from "@esa/api";
import {environment} from "../../../../../environments/environment";
import {NotificationsSelectors} from "../../../store/selectors";
import {NotificationActions} from "../../../store/actions";
import {NavigationService} from "../../../services/navigation.service";
import {AdminCheckService} from "../../../services/admin-check.service";

@Component({
  selector: 'navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  @Input() set currentUser(ude: UserDtoExtended){
    this.loggedInUser = ude;

    this.isAdmin = this.adminCheckService.isAdmin(ude);
    const roleName = ude?.role?.roleName?.toLowerCase();
    this.canManageCaseCategories = roleName?.includes('admin') || roleName === 'hoa';
  };

  isClosed: boolean = false;
  selected: string = 'Dashboard';
  isDarkTheme: boolean = false;
  isNavbarSticky: boolean = false;
  navbarOffsetTop: number = 0;
  openPanel: boolean = false;
  isAdmin: boolean = false;
  canManageCaseCategories: boolean = false;
  loggedInUser: UserDtoExtended;

  notifications$ = this._store.pipe(select(NotificationsSelectors.getNotifications));
  recentNotificationsCount$ = this.notifications$.pipe(
    map((notifications: any) => notifications.filter((notification: any) => {
      const notificationDate = new Date(notification.created);
      const now = new Date();
      const diffInHours = Math.abs(now.getTime() - notificationDate.getTime()) / 36e5;
      return diffInHours <= 48 && notification.notificationStatus !== NotificationStatusEnum.READ;
    }).length)
  );
  isProduction: boolean = environment.production;
  appVersion: string = environment.appVersion;
  apiVersion: string = OpenAPI.VERSION;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    this.isNavbarSticky = scrollPosition >= this.navbarOffsetTop;
  }

  constructor(
    private router: Router,
    private msalAuthService: MsalService,
    private _store: Store,
    private navigationService: NavigationService,
    private adminCheckService: AdminCheckService
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.updateSelectedNavItem();
      }
    });
    this._store.dispatch(NotificationActions.getNotifications());
  }

  ngAfterViewInit() {
    const navbarElement = document.querySelector('.navbar') as HTMLElement;
    this.navbarOffsetTop = navbarElement.offsetTop;
  }

  ngOnInit() {
    const savedTheme = localStorage.getItem('theme');
    this.isDarkTheme = savedTheme === 'dark';

    this.setTheme(this.isDarkTheme);
    this.updateSelectedNavItem();
  }

  toggleSidebar() {
    this.isClosed = !this.isClosed;
  }

  selectItem(item: string, route: string) {
    this.selected = item;
    this.router.navigate([route]);
  }

  openNotificationPanel() {
    this.openPanel = !this.openPanel;
  }

  onPanelClosed(event: boolean) {
    this.openPanel = event;
  }

  toggleTheme() {
    this.isDarkTheme = !this.isDarkTheme;
    const theme = this.isDarkTheme ? 'dark' : 'light';
    document.body.setAttribute('data-theme', theme);

    localStorage.setItem('theme', this.isDarkTheme ? 'dark' : 'light');
  }

  private setTheme(isDark: boolean) {
    const theme = isDark ? 'dark' : 'light';
    document.body.setAttribute('data-theme', theme);
  }

  private updateSelectedNavItem() {
    const currentRoute: string = this.router.url.split('#')[0];
    this.navigationService.updateSelectedItem(currentRoute);
    const routeMap = {
      '^/dashboard$': 'Dashboard',
      '^/case-management/case-categories$': 'Case Categories',
      '^/case-management/request-types$': 'Request Types',
      '^/case-management.*$': 'Case Management',
      '^/working-groups$': 'Working Groups',
      '^/community-content$': 'Community Content',
      '^/notifications$': 'Notifications',
      '^/chat$': 'Chat',
      '^/users$': 'Users',
      '^/fiu-management$': 'FIU Management'
    };

    if (currentRoute !== '/') {
      for (const route in routeMap) {
        if (new RegExp(route).test(currentRoute)) {
          this.selected = routeMap[route as keyof typeof routeMap];
          break;
        }
      }
    }
  }

  // logout() {
  //   this.msalAuthService.logoutRedirect();
  // }
}
